import { ActionsUnion, createAction } from 'spw-redux/types';
import {
  ISpaceTypeCategory,
  SpaceTypeColor,
} from 'spw-redux/modules/space_types/types';
import { SpaceTypeCategoryMap } from 'spw-redux/modules/floorplan/types';
import { IUser } from 'spw-redux/modules/user/types';
import {
  IProject,
  IBuilding,
  IFloor,
  IDepartment,
  IProjectColors,
  IUserFavoriteProject,
  ProjectStatus,
  GetProjectsParams,
  UserRoleInProject,
  HeadcountLevel,
  Headcount,
  HeadcountType,
} from './types';
import { SimplifiedUserSortOptions, UserVM } from '../users/types';
import { Client } from '../clients/types';

export const SAVE_PROJECT = 'projects/CREATE_PROJECT';
export const SAVE_PROJECT_SUCCEEDED = 'projects/CREATE_PROJECT_SUCCEEDED';
export const GET_PROJECTS = 'projects/GET_PROJECTS';
export const GET_PROJECTS_SUCCEEDED = 'projects/GET_PROJECTS_SUCCEEDED';
export const SAVE_DEPARTMENT = 'projects/SAVE_DEPARTMENT';
export const GET_DEPARTMENTS_BY_PROJECT_ID =
  'projects/GET_DEPARTMENTS_BY_PROJECT_ID';
export const GET_DEPARTMENTS_BY_PROJECT_ID_SUCCEEDED =
  'projects/GET_DEPARTMENTS_BY_PROJECT_ID_SUCCEEDED';
export const UPDATE_DEPARTMENT = 'projects/UPDATE_DEPARTMENT';
export const DELETE_DEPARTMENT = 'projects/DELETE_DEPARTMENT';
export const UPDATE_DEPARTMENTS = 'projects/UPDATE_DEPARTMENTS';
export const UPDATE_DEPARTMENTS_SUCCESS = 'projects/UPDATE_DEPARTMENTS_SUCCESS';
export const TOGGLE_HEADCOUNT_MODAL = 'projects/TOGGLE_HEADCOUNT_MODAL';
export const SAVE_PROJECT_YEAR = 'projects/SAVE_PROJECT_YEAR';
export const UPDATE_PROJECT_YEAR = 'projects/UPDATE_PROJECT_YEAR';
export const SAVE_BUILDING = 'projects/SAVE_BUILDING';
export const SAVE_EDITING_BUILDING = 'projects/SAVE_EDITING_BUILDING';
export const DELETE_BUILDING = 'projects/DELETE_BUILDING';
export const BULK_UPDATE_BUILDING_INDICES =
  'projects/BULK_UPDATE_BUILDING_INDICES';
export const UPDATE_PROJECT_BUILDINGS_SUCCEEDED =
  'projects/UPDATE_PROJECT_BUILDINGS_SUCCEEDED';
export const CHANGE_CLIENT_DIALOG_STATE = 'projects/CHANGE_CLIENT_DIALOG_STATE';
export const CHANGE_PROJECT_DIALOG_STATE =
  'projects/CHANGE_PROJECT_DIALOG_STATE';
export const CHANGE_BUILDING_DIALOG_STATE =
  'projects/CHANGE_BUILDING_DIALOG_STATE';
export const CHANGE_COSTS_AND_FEES_DIALOG_STATE =
  'projects/CHANGE_COSTS_AND_FEES_DIALOG_STATE';
export const SET_CURRENT_PROJECT = 'projects/SET_CURRENT_PROJECT';
export const SET_CURRENT_BUILDING = 'projects/SET_CURRENT_BUILDING';
export const UPDATE_CURRENT_BUILDING = 'projects/UPDATE_CURRENT_BUILDING';
export const UPDATE_NUMBER_OF_DEPARTMENTS =
  'projects/UPDATE_NUMBER_OF_DEPARTMENTS';
export const UPDATE_NUMBER_OF_SCENARIOS = 'projects/UPDATE_NUMBER_OF_SCENARIOS';
export const REFRESH_CURRENT_PROJECT = 'projects/REFRESH_CURRENT_PROJECT';
export const GET_PROJECT_INFO_BY_ID = 'projects/GET_PROJECT_INFO_BY_ID';
export const GET_PROJECT_INFO_BY_ID_SUCCEEDED =
  'projects/GET_PROJECT_INFO_BY_ID_SUCCEEDED';
export const CLEAR_SELECTED_PROJECT = 'projects/CLEAR_SELECTED_PROJECT';
export const UPDATE_BUILDING_FLOOR = 'projects/UPDATE_BUILDING_FLOOR';
export const DELETE_BUILDING_FLOOR = 'projects/DELETE_BUILDING_FLOOR';
export const INSERT_FLOOR_ABOVE = 'projects/INSERT_FLOOR_ABOVE';
export const INSERT_FLOOR_BELOW = 'projects/INSERT_FLOOR_BELOW';
export const MOVE_FLOOR_UP = 'projects/MOVE_FLOOR_UP';
export const MOVE_FLOOR_DOWN = 'projects/MOVE_FLOOR_DOWN';
export const RECORD_PROJECT_ACTIVITY = 'projects/RECORD_PROJECT_ACTIVITY';
export const SET_CURRENT_FLOOR = 'projects/SET_CURRENT_FLOOR';
export const GET_SPACE_TYPE_CATEGORIES = 'projects/GET_SPACE_TYPE_CATEGORIES';
export const GET_SPACE_TYPE_CATEGORIES_SUCCEEDED =
  'projects/GET_SPACE_TYPE_CATEGORIES_SUCCEEDED';
export const SET_PROJECT_TYPE = 'projects/SET_PROJECT_TYPE';
export const ARCHIVE_PROJECT = 'projects/ARCHIVE_PROJECT';
export const CLONE_PROJECT = 'projects/CLONE_PROJECT';
export const SET_CLONING_PROJECT_ID = 'projects/SET_CLONING_PROJECT_ID';
export const CLEAR_SPACE_TYPE_CATEGORIES =
  'projects/CLEAR_SPACE_TYPE_CATEGORIES';
export const FETCH_PROJECT_COLORS = 'projects/FETCH_PROJECT_COLORS';
export const FETCH_PROJECT_COLORS_SUCCEEDED =
  'projects/FETCH_PROJECT_COLORS_SUCCEEDED';
export const SET_PROJECT_COLOR = 'projects/SET_PROJECT_COLOR';
export const UPDATE_PROJECT_COLORS = 'projects/UPDATE_PROJECT_COLORS';
export const SET_CURRENT_PROJECT_COLORS = 'projects/SET_CURRENT_PROJECT_COLORS';
export const GET_USER_FAVORITE_PROJECTS_LEGACY =
  'projects/GET_USER_FAVORITE_PROJECTS_LEGACY';
export const GET_USER_FAVORITE_PROJECTS_LEGACY_SUCCEEDED =
  'projects/GET_USER_FAVORITE_PROJECTS_LEGACY_SUCCEEDED';
export const DELETE_USER_FAVORITE_PROJECT_LEGACY =
  'projects/DELETE_USER_FAVORITE_PROJECT_LEGACY';
export const DELETE_USER_FAVORITE_PROJECT =
  'projects/DELETE_USER_FAVORITE_PROJECT';
export const DELETE_USER_FAVORITE_PROJECT_SUCCEEDED =
  'projects/DELETE_USER_FAVORITE_PROJECT_SUCCEEDED';
export const CREATE_USER_FAVORITE_PROJECT =
  'projects/CREATE_USER_FAVORITE_PROJECT';
export const CREATE_USER_FAVORITE_PROJECT_SUCCEEDED =
  'projects/CREATE_USER_FAVORITE_PROJECT_SUCCEEDED';
export const GET_ORGANIZATION_USERS = 'projects/GET_ORGANIZATION_USERS';
export const GET_ORGANIZATION_USERS_SUCCEEDED =
  'projects/GET_ORGANIZATION_USERS_SUCCEEDED';
export const SET_PROJECT_DETAIL_SELECTED_TAB =
  'projects/SET_PROJECT_DETAIL_SELECTED_TAB';
export const SET_PROJECT_DETAIL_NEXT_SELECTED_TAB =
  'projects/SET_PROJECT_DETAIL_NEXT_SELECTED_TAB';
export const CLEAN_UP_CURRENT_PROJECT = 'projects/CLEAN_UP_CURRENT_PROJECT';
export const JOIN_CURRENT_PROJECT = 'projects/JOIN_CURRENT_PROJECT';
export const JOIN_CURRENT_PROJECT_SUCCEEDED =
  'projects/JOIN_CURRENT_PROJECT_SUCCEEDED';
export const JOIN_CURRENT_PROJECT_SUCCEEDED_FAILED =
  'projects/JOIN_CURRENT_PROJECT_SUCCEEDED_FAILED';
export const JOIN_PROJECT = 'projects/JOIN_PROJECT';
export const JOIN_PROJECT_SUCCEEDED = 'projects/JOIN_PROJECT_SUCCEEDED';
export const JOIN_PROJECT_FAILED = 'projects/JOIN_PROJECT_FAILED';
export const ISSUE_REQUEST_TO_JOIN_PROJECT =
  'projects/ISSUE_REQUEST_TO_JOIN_PROJECT';
export const ISSUE_REQUEST_TO_JOIN_PROJECT_SUCCEEDED =
  'projects/ISSUE_REQUEST_TO_JOIN_PROJECT_SUCCEEDED';
export const ISSUE_REQUEST_TO_JOIN_PROJECT_FAILED =
  'projects/ISSUE_REQUEST_TO_JOIN_TEAM_FAILED';
export const GET_PROJECT_EDITORS = 'projects/GET_PROJECT_EDITORS';
export const GET_PROJECT_EDITORS_SUCCEEDED =
  'projects/GET_PROJECT_EDITORS_SUCCEEDED';
export const GET_PROJECT_EDITORS_FAILED = 'projects/GET_PROJECT_EDITORS_FAILED';
export const REMOVE_PROJECT_EDITOR = 'projects/REMOVE_PROJECT_EDITOR';
export const REMOVE_PROJECT_EDITOR_SUCCEEDED =
  'projects/REMOVE_PROJECT_EDITOR_SUCCEEDED';
export const REMOVE_PROJECT_EDITOR_FAILED =
  'projects/REMOVE_PROJECT_EDITOR_FAILED';
export const ADD_TEAMS_TO_PROJECT = 'projects/ADD_TEAMS_TO_PROJECT';
export const ADD_PROJECT_EDITORS = 'projects/ADD_PROJECT_EDITORS';
export const REMOVE_TEAM_FROM_PROJECT = 'projects/REMOVE_TEAM_FROM_PROJECT';
export const TRANSFER_PROJECT_OWNERSHIP = 'projects/TRANSFER_PROJECT_OWNERSHIP';
export const TRANSFER_PROJECT_OWNERSHIP_SUCCEEDED =
  'projects/TRANSFER_PROJECT_OWNERSHIP_SUCCEEDED';
export const LEAVE_PROJECT = 'projects/LEAVE_PROJECT';
export const LEAVE_PROJECT_SUCCEEDED = 'projects/LEAVE_PROJECT_SUCCEEDED';
export const UPDATE_LAST_EDITOR_WITH_CURRENT_USER =
  'projects/UPDATE_LAST_EDITOR_WITH_CURRENT_USER';
export const UPDATE_HEADCOUNTS = 'projects/UPDATE_HEADCOUNTS';
export const UPDATE_PROJECT_HEADCOUNT_TYPE =
  'projects/UPDATE_PROJECT_HEADCOUNT_TYPE';
export const SET_PREVIOUSLY_VISITED_BENCHMARK_PROJECT_ID =
  'SET_PREVIOUSLY_VISITED_BENCHMARK_PROJECT_ID';

export const saveProject = (
  project: IProject,
  onSaveSucceeded?: (savedProjectId: number) => void
) => createAction(SAVE_PROJECT, { project, onSaveSucceeded });
export const saveProjectSucceeded = (project: IProject) =>
  createAction(SAVE_PROJECT_SUCCEEDED, { project });

export const saveBuilding = (building: IBuilding) =>
  createAction(SAVE_BUILDING, { building });
export const saveEditingBuilding = (building: Partial<IBuilding>) =>
  createAction(SAVE_EDITING_BUILDING, { building });
export const deleteBuilding = (buildingId: number) =>
  createAction(DELETE_BUILDING, { buildingId });
export const bulkUpdateBuildingIndices = (buildings: IBuilding[]) =>
  createAction(BULK_UPDATE_BUILDING_INDICES, { buildings });
export const updateProjectBuildingsSucceeded = (buildings: IBuilding[]) =>
  createAction(UPDATE_PROJECT_BUILDINGS_SUCCEEDED, { buildings });

export const saveDepartment = (department: IDepartment) =>
  createAction(SAVE_DEPARTMENT, { department });

export const deleteDepartment = (departmentId: number) =>
  createAction(DELETE_DEPARTMENT, { departmentId });

export const changeBuildingDialogState = (
  isOpen: boolean,
  showNewBuildingModal = false,
  building?: IBuilding
) =>
  createAction(CHANGE_BUILDING_DIALOG_STATE, {
    isOpen,
    showNewBuildingModal,
    building,
  });
export const changeClientDialogState = (isOpen: boolean) =>
  createAction(CHANGE_CLIENT_DIALOG_STATE, { isOpen });
export const changeProjectDialogState = (isOpen: boolean) =>
  createAction(CHANGE_PROJECT_DIALOG_STATE, { isOpen });
export const changeCostsAndFeesDialogState = (isOpen: boolean) =>
  createAction(CHANGE_COSTS_AND_FEES_DIALOG_STATE, { isOpen });

export const getDepartmentsByProjectId = (
  projectId: IDepartment['projectId']
) => createAction(GET_DEPARTMENTS_BY_PROJECT_ID, { projectId });
export const getDepartmentsByProjectIdSucceeded = (
  departments: IDepartment[]
) => {
  return createAction(GET_DEPARTMENTS_BY_PROJECT_ID_SUCCEEDED, { departments });
};
export const updateDepartment = (department: IDepartment) =>
  createAction(UPDATE_DEPARTMENT, { department });
export const updateDepartments = (departments: IDepartment[]) =>
  createAction(UPDATE_DEPARTMENTS, { departments });
export const updateDepartmentsSuccess = (departments: IDepartment[]) =>
  createAction(UPDATE_DEPARTMENTS_SUCCESS, { departments });
export const updateNumberOfDepartments = (numberOfDepartments: number) =>
  createAction(UPDATE_NUMBER_OF_DEPARTMENTS, { numberOfDepartments });
export const updateNumberOfScenarios = (numberOfScenarios: number) =>
  createAction(UPDATE_NUMBER_OF_SCENARIOS, { numberOfScenarios });
export const getSpaceTypeCategories = () =>
  createAction(GET_SPACE_TYPE_CATEGORIES);
export const getSpaceTypeCategoriesSucceeded = (
  spaceTypeCategories: ISpaceTypeCategory[],
  spaceTypeCategoriesMap: SpaceTypeCategoryMap
) =>
  createAction(GET_SPACE_TYPE_CATEGORIES_SUCCEEDED, {
    spaceTypeCategories,
    spaceTypeCategoriesMap,
  });
export const clearSpaceCategories = () =>
  createAction(CLEAR_SPACE_TYPE_CATEGORIES);

export const getProjects = (params?: GetProjectsParams) =>
  createAction(GET_PROJECTS, params);
export const getProjectsSucceeded = (payload: {
  projects: IProject[];
  totalFilteredProjects: number;
}) => createAction(GET_PROJECTS_SUCCEEDED, payload);
export const setCurrentProject = (project: IProject) =>
  createAction(SET_CURRENT_PROJECT, { project });
export const setCurrentBuilding = (
  building: IBuilding | undefined,
  keepFloor?: boolean
) => createAction(SET_CURRENT_BUILDING, { building, keepFloor });
export const updateCurrentBuilding = (building: IBuilding) =>
  createAction(UPDATE_CURRENT_BUILDING, { building });

export const refreshCurrentProject = () =>
  createAction(REFRESH_CURRENT_PROJECT);

export const getProjectInfoById = (projectId: number) =>
  createAction(GET_PROJECT_INFO_BY_ID, { projectId });
export const getProjectInfoByIdSucceeded = (project: IProject) =>
  createAction(GET_PROJECT_INFO_BY_ID_SUCCEEDED, { project });
export const clearSelectedProject = () => createAction(CLEAR_SELECTED_PROJECT);
export const updateBuildingFloor = (
  floor: IFloor & { deleteShape?: boolean },
  blockRedirect?: boolean,
  updatesUsf = false
) => createAction(UPDATE_BUILDING_FLOOR, { floor, blockRedirect, updatesUsf });
export const deleteBuildingFloor = (
  floor: IFloor,
  redirect?: (floor: IFloor, shouldReplaceLocation?: boolean) => void
) => createAction(DELETE_BUILDING_FLOOR, { floor, redirect });
export const insertFloorAbove = (
  floor: IFloor,
  redirect?: (floor: IFloor) => void
) => createAction(INSERT_FLOOR_ABOVE, { floor, redirect });
export const insertFloorBelow = (
  floor: IFloor,
  redirect?: (floor: IFloor) => void
) => createAction(INSERT_FLOOR_BELOW, { floor, redirect });
export const moveFloorUp = (floor: IFloor) =>
  createAction(MOVE_FLOOR_UP, { floor });
export const moveFloorDown = (floor: IFloor) =>
  createAction(MOVE_FLOOR_DOWN, { floor });
export const recordProjectActivity = (projectId: number) =>
  createAction(RECORD_PROJECT_ACTIVITY, { projectId });
export const setCurrentFloor = (floor: IFloor) =>
  createAction(SET_CURRENT_FLOOR, { floor });
export const toggleHeadcountModal = (openHeadcountModal: boolean) =>
  createAction(TOGGLE_HEADCOUNT_MODAL, { openHeadcountModal });
export const saveProjectYear = (year: number) =>
  createAction(SAVE_PROJECT_YEAR, { year });
export const updateProjectYear = (year: number) =>
  createAction(UPDATE_PROJECT_YEAR, { year });
export const setProjectType = (projectType: string) =>
  createAction(SET_PROJECT_TYPE, { projectType });
export const archiveProject = (
  project: IProject,
  params?: {
    shouldRefreshProjectsAfterwards: boolean;
    onArchiveSucceeded?: () => void;
  }
) => createAction(ARCHIVE_PROJECT, { project, ...params });

export const cloneProject = (
  params: {
    createdByUserId: number;
    projectId: number;
    projectName: string;
    client: Partial<Client>;
    city: string;
    state: string;
    countryCode: string;
    projectNumber: string;
    status?: ProjectStatus;
    requiresRequestToJoin?: boolean;
    selectedBuildingIds?: number[];
  },
  onCloneSucceeded?: (projectId: number) => void
) =>
  createAction(CLONE_PROJECT, {
    ...params,
    onCloneSucceeded,
  });
export const setCloningProjectId = (projectId: number) =>
  createAction(SET_CLONING_PROJECT_ID, { projectId });
export const fetchProjectColors = () => createAction(FETCH_PROJECT_COLORS);
export const fetchProjectColorsSucceeded = (colors: IProjectColors) =>
  createAction(FETCH_PROJECT_COLORS_SUCCEEDED, { colors });
export const setProjectColor = (projectColors: Record<string, unknown>) =>
  createAction(SET_PROJECT_COLOR, { projectColors });

export const setCurrentProjectColors = (colors: {
  subcategories: Record<string, { color: string; gradientColorIndex: number }>;
}) => createAction(SET_CURRENT_PROJECT_COLORS, { colors });

export const updateProjectColors = (projectColors: {
  subcategoryColors: { id: number; color: string }[];
  spaceTypeColors: SpaceTypeColor[];
}) => createAction(UPDATE_PROJECT_COLORS, { projectColors });

export const getUserFavoriteProjectsLegacy = (type: string) =>
  createAction(GET_USER_FAVORITE_PROJECTS_LEGACY, { type });
export const getUserFavoriteProjectsLegacySucceeded = (
  userFavoriteProjectsLegacy: IUserFavoriteProject[]
) =>
  createAction(GET_USER_FAVORITE_PROJECTS_LEGACY_SUCCEEDED, {
    userFavoriteProjectsLegacy,
  });
export const deleteUserFavoriteProjectLegacy = (
  userFavoriteProjectId: number
) =>
  createAction(DELETE_USER_FAVORITE_PROJECT_LEGACY, { userFavoriteProjectId });
export const deleteUserFavoriteProject = (params: {
  projectId: number;
  onSuccess?: () => void;
}) => createAction(DELETE_USER_FAVORITE_PROJECT, params);
export const deleteUserFavoriteProjectSucceeded = ({
  projectId,
}: {
  projectId: number;
}) => createAction(DELETE_USER_FAVORITE_PROJECT_SUCCEEDED, { projectId });
export const createUserFavoriteProject = (
  projectId: number,
  params: { shouldRefreshProjectsAfterwards: boolean },
  onSuccess?: () => void
) =>
  createAction(CREATE_USER_FAVORITE_PROJECT, {
    projectId,
    onSuccess,
    ...params,
  });
export const createUserFavoriteProjectSucceeded = ({
  projectId,
}: {
  projectId: number;
}) => createAction(CREATE_USER_FAVORITE_PROJECT_SUCCEEDED, { projectId });
export const getOrganizationUsers = (organizationId: number) =>
  createAction(GET_ORGANIZATION_USERS, { organizationId });
export const getOrganizationUsersSucceeded = (organizationUsers: IUser[]) =>
  createAction(GET_ORGANIZATION_USERS_SUCCEEDED, { organizationUsers });
export const setProjectDetailSelectedTab = (selectedTab: number | null) =>
  createAction(SET_PROJECT_DETAIL_SELECTED_TAB, { selectedTab });
export const setProjectDetailNextSelectedTab = (
  nextSelectedTab: number | null
) => createAction(SET_PROJECT_DETAIL_NEXT_SELECTED_TAB, { nextSelectedTab });

export const cleanUpCurrentProject = () =>
  createAction(CLEAN_UP_CURRENT_PROJECT);

export const joinCurrentProject = () => createAction(JOIN_CURRENT_PROJECT);

export const joinCurrentProjectSucceeded = (newUserRole: UserRoleInProject) =>
  createAction(JOIN_CURRENT_PROJECT_SUCCEEDED, newUserRole);

export const joinCurrentProjectFailed = () =>
  createAction(JOIN_CURRENT_PROJECT_SUCCEEDED_FAILED);

export const joinProject = (id: number) => createAction(JOIN_PROJECT, { id });
export const joinProjectSucceeded = (id: number) =>
  createAction(JOIN_PROJECT_SUCCEEDED, { id });
export const joinProjectFailed = () => createAction(JOIN_PROJECT_FAILED);

export const issueRequestToJoinProject = (
  id: number,
  getPendingRequestsOfAllProjects?: boolean
) =>
  createAction(ISSUE_REQUEST_TO_JOIN_PROJECT, {
    id,
    getPendingRequestsOfAllProjects,
  });

export const issueRequestToJoinProjectSucceeded = () =>
  createAction(ISSUE_REQUEST_TO_JOIN_PROJECT_SUCCEEDED);

export const issueRequestToJoinProjectFailed = () =>
  createAction(ISSUE_REQUEST_TO_JOIN_PROJECT_FAILED);

export const getProjectEditors = (payload: {
  projectId: number;
  page?: number;
  perPage?: number;
  sort?: SimplifiedUserSortOptions;
}) => createAction(GET_PROJECT_EDITORS, payload);

export const getProjectEditorsSucceeded = (results: {
  total: number;
  projectEditors: UserVM[];
}) => createAction(GET_PROJECT_EDITORS_SUCCEEDED, results);

export const getProjectEditorsFailed = () =>
  createAction(GET_PROJECT_EDITORS_FAILED);

export const removeProjectEditor = (
  userId: number,
  projectId: number,
  onSuccess?: () => void
) => createAction(REMOVE_PROJECT_EDITOR, { projectId, userId, onSuccess });

export const removeProjectEditorSucceeded = (removedEditorId: number) =>
  createAction(REMOVE_PROJECT_EDITOR_SUCCEEDED, removedEditorId);

export const removeProjectEditorFailed = () =>
  createAction(REMOVE_PROJECT_EDITOR_FAILED);

export const addTeamsToProject = (params: {
  teamIds: number[];
  projectId: number;
  onAddTeamsSucceded?: () => void;
}) => createAction(ADD_TEAMS_TO_PROJECT, params);
export const addProjectEditors = (params: {
  userIds: number[];
  projectId: number;
  onSuccess?: () => void;
}) => createAction(ADD_PROJECT_EDITORS, params);

export const removeTeamFromProject = (params: {
  projectId: number;
  teamId: number;
  onRemoveTeamSucceeded?: () => void;
}) => createAction(REMOVE_TEAM_FROM_PROJECT, params);

export const transferProjectOwnership = (params: {
  projectId: number;
  user: IUser;
  preservePreviousOwnerAsEditor: boolean;
  onSuccess?: () => void;
}) => createAction(TRANSFER_PROJECT_OWNERSHIP, params);

export const transferProjectOwnershipSucceeded = (params: {
  projectId: number;
  user: IUser;
  preservePreviousOwnerAsEditor: boolean;
}) => createAction(TRANSFER_PROJECT_OWNERSHIP_SUCCEEDED, params);

export const leaveProject = (params: {
  projectId: number;
  onSuccess?: () => void;
}) => createAction(LEAVE_PROJECT, params);

export const leaveProjectSucceeded = (projectId: number) =>
  createAction(LEAVE_PROJECT_SUCCEEDED, { projectId });

export const updateLastEditorWithCurrentUser = () =>
  createAction(UPDATE_LAST_EDITOR_WITH_CURRENT_USER);

export const updateHeadcounts = (
  headcounts: Headcount[],
  level: HeadcountLevel
) => createAction(UPDATE_HEADCOUNTS, { headcounts, level });

export const updateProjectHeadcountType = (headcountType: HeadcountType) =>
  createAction(UPDATE_PROJECT_HEADCOUNT_TYPE, { headcountType });

export const setPreviouslyVisitedBenchmarkProjectId = (id: number) =>
  createAction(SET_PREVIOUSLY_VISITED_BENCHMARK_PROJECT_ID, { id });

export const actions = {
  changeBuildingDialogState,
  changeClientDialogState,
  changeCostsAndFeesDialogState,
  changeProjectDialogState,
  clearSelectedProject,
  deleteBuildingFloor,
  getDepartmentsByProjectId,
  getDepartmentsByProjectIdSucceeded,
  refreshCurrentProject,
  getProjectInfoById,
  getProjectInfoByIdSucceeded,
  getProjects,
  getProjectsSucceeded,
  getSpaceTypeCategories,
  getSpaceTypeCategoriesSucceeded,
  insertFloorAbove,
  insertFloorBelow,
  moveFloorDown,
  moveFloorUp,
  recordProjectActivity,
  saveBuilding,
  saveDepartment,
  saveEditingBuilding,
  saveProject,
  saveProjectSucceeded,
  setCurrentBuilding,
  updateCurrentBuilding,
  setCurrentFloor,
  setCurrentProject,
  toggleHeadcountModal,
  updateBuildingFloor,
  updateProjectBuildingsSucceeded,
  updateDepartment,
  updateDepartments,
  updateDepartmentsSuccess,
  updateNumberOfDepartments,
  updateNumberOfScenarios,
  setProjectType,
  deleteBuilding,
  bulkUpdateBuildingIndices,
  archiveProject,
  cloneProject,
  setCloningProjectId,
  deleteDepartment,
  clearSpaceCategories,
  fetchProjectColors,
  fetchProjectColorsSucceeded,
  setProjectColor,
  setCurrentProjectColors,
  updateProjectColors,
  saveProjectYear,
  updateProjectYear,
  getUserFavoriteProjectsLegacy,
  getUserFavoriteProjectsLegacySucceeded,
  deleteUserFavoriteProjectLegacy,
  deleteUserFavoriteProject,
  deleteUserFavoriteProjectSucceeded,
  createUserFavoriteProject,
  createUserFavoriteProjectSucceeded,
  getOrganizationUsers,
  getOrganizationUsersSucceeded,
  setProjectDetailSelectedTab,
  setProjectDetailNextSelectedTab,
  cleanUpCurrentProject,
  joinCurrentProject,
  joinCurrentProjectSucceeded,
  joinCurrentProjectFailed,
  joinProject,
  joinProjectSucceeded,
  joinProjectFailed,
  issueRequestToJoinProject,
  issueRequestToJoinProjectSucceeded,
  issueRequestToJoinProjectFailed,
  getProjectEditors,
  getProjectEditorsSucceeded,
  getProjectEditorsFailed,
  removeProjectEditor,
  removeProjectEditorSucceeded,
  removeProjectEditorFailed,
  addTeamsToProject,
  addProjectEditors,
  transferProjectOwnership,
  transferProjectOwnershipSucceeded,
  leaveProject,
  leaveProjectSucceeded,
  removeTeamFromProject,
  updateLastEditorWithCurrentUser,
  updateHeadcounts,
  updateProjectHeadcountType,
  setPreviouslyVisitedBenchmarkProjectId,
};

export type Actions = ActionsUnion<typeof actions>;
